export default "__VITE_ASSET__1f6799df__"